import React, { useState, useRef } from 'react';
import './ImageSwiper.css';
import cameraIcon from '../Icons/camara.jpg';

const ImageSwiper = ({ imagenes = [], imagen = '', nombre = '' }) => {
  const [current, setCurrent] = useState(0);
  const startX = useRef(null);

  const imgs = (imagenes?.length > 0 ? imagenes : imagen ? [imagen] : []).filter(Boolean);

  if (imgs.length === 0) return <img src={cameraIcon} alt={nombre} className="swiper-single" />;
  if (imgs.length === 1) return <img src={imgs[0]} alt={nombre} className="swiper-single" />;

  const prev = (e) => { e.stopPropagation(); setCurrent(c => (c - 1 + imgs.length) % imgs.length); };
  const next = (e) => { e.stopPropagation(); setCurrent(c => (c + 1) % imgs.length); };

  const handleTouchStart = (e) => { startX.current = e.touches[0].clientX; };
  const handleTouchEnd  = (e) => {
    if (startX.current === null) return;
    const diff = startX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) diff > 0 ? next(e) : prev(e);
    startX.current = null;
  };

  return (
    <div className="swiper-wrapper" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      <img src={imgs[current]} alt={`${nombre} ${current + 1}`} className="swiper-img" />
      <button className="swiper-btn swiper-prev" onClick={prev}>‹</button>
      <button className="swiper-btn swiper-next" onClick={next}>›</button>
      <span className="swiper-counter">{current + 1}/{imgs.length}</span>
      <div className="swiper-dots">
        {imgs.map((_, i) => (
          <span key={i}
            className={`swiper-dot${i === current ? ' active' : ''}`}
            onClick={(e) => { e.stopPropagation(); setCurrent(i); }}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageSwiper;